// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OwnerLogin from './components/auth/OwnerLogin';
import OwnerSignup from './components/auth/OwnerSignup';
import CustomerLogin from './components/auth/CustomerLogin';
// import CustomerLogin from './components/customer/CustomerLogin';
import VerifyOTP from './components/auth/VerifyOTP';

import AdminDashboard from './components/dashboard/AdminDashboard';
import OwnerDashboard from './components/dashboard/OwnerDashboard';
import CustomerDashboard from './components/dashboard/CustomerDashboard';
import ProtectedRoute from './components/ProtectedRoute';

import RestaurantList from './components/owner/RestaurantList';
import CreateRestaurant from './components/restaurants/CreateRestaurant';
import SubscriberList from './components/subscribers/SubscriberList';
// import CouponList from './components/duplicates-or-notused/CouponList';
// import CreateCouponForm from './components/duplicates-or-notused/CreateCouponForm';

import Header from './components/common/Header';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastWrapper } from './components/common/Toast';

import UnsubscribePage from './components/auth/UnsubscribePage';

// import OwnerDashboard from './components/dashboard/OwnerDashboard';
// import CustomerDashboard from './components/dashboard/CustomerDashboard';
// import TextMessageForm from './components/textmessages/TextMessageForm';
import CouponTemplateManagement from './components/restaurants/CouponTemplateManagement';
import Login from './components/auth/OwnerLogin';
// import VerifyOTP from './components/auth/VerifyOTP';
import QRCodeSubscribePage from './components/QRCodeSubscribePage';

import RestaurantActionsPage from './components/duplicates-or-notused/restaurant-RestaurantActionsPage';
import RestaurantDashboard from './components/dashboard/RestaurantDashboard';
// import ToastNotification from './components/common/ToastNotification';

import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import SubscribersPage from './components/restaurants/SubscribersPage';

import LandingPage from './components/LandingPage';
import TextMessagePage from './components/restaurants/TextMessagePage';
import QRCodePage from './components/restaurants/QRCodePage';
// import SubscriberList from './components/subscribers/SubscriberList';
// import ForgotPassword from './components/auth/ResetPassword';

import WelcomeTextPage from './components/restaurants/WelcomeTextPage';
import RestaurantDetails from './components/restaurants/RestaurantDetails';
import MembershipPage from './components/membership/MembershipPage';

// import TextMessageList from './components/messages/TextMessageForm';
import TextMessageCreate from './components/duplicates-or-notused/TextMessageCreate';
import TextMessageCreateTwo from './components/textmessages/TextMessageCreateTwo';
import TextMessageForm from './components/duplicates-or-notused/TextMessageForm';
import TextMessageFormTwo from './components/textmessages/TextMessageFormTwo';
import TextMessageList from './components/textmessages/TextMessageList';
import TextMessageListTwo from './components/textmessages/TextMessageListTwo';
import TextMessages from './components/duplicates-or-notused/TextMessages';
import TextMessagesPage from './components/textmessages/TextMessagesPage';
import TextMessageDetail from './components/textmessages/TextMessageDetail';

import TextMessageFormRes from './components/restaurants/TextMessageForm';
import TextMessagePageRes from './components/restaurants/TextMessagePage';
import CustomerSubscribe from './components/CustomerSubscribe';

import CouponRedemptionPage from './components/coupons/CouponRedemptionPage';
import SubscriberListTwo from './components/subscribers/SubscriberListTwo';
import Dashboard from './components/dashboard/Dashboard';
import NotFound from './components/NotFound';
import { ThemeProvider } from './components/new/ThemeContext';
import Home from './components/restaurants/Home';
import CustomerHome from './components/customer/CustomerHome';

import CouponForm from './components/restaurants/CouponForm';
import LandingPageTwo from './components/LandingPageTwo';

import AdminCoupons from './components/admin/new/AdminCoupons';
import AdminSubscribers from './components/admin/new/AdminSubscribers';
import AdminTextMessages from './components/admin/new/AdminTextMessages';
import AdminRestaurants from './components/admin/new/AdminRestaurants';
import AdminLogin from './components/admin/new/AdminLogin';
import AdminSignup from './components/auth/AdminSignup';
import AdminMemberships from './components/admin/new/AdminMemberships';
import AdminOwners from './components/admin/new/AdminOwners';
import AdminCustomers from './components/admin/new/AdminCustomers';
import AdminCouponTemplates from './components/admin/new/AdminCouponTemplates';
import AdminCreateRestaurant from './components/admin/new/AdminCreateRestaurant';
import AdminCreateOwner from './components/admin/new/AdminCreateOwner';
import AdminCreateCustomer from './components/admin/new/AdminCreateCustomer';
import AdminCreateCouponTemplate from './components/admin/new/AdminCreateCouponTemplate';
import AdminCreateCoupon from './components/admin/new/AdminCreateCoupon';
import AdminCreateTextMessage from './components/admin/new/AdminCreateTextMessage';
import AdminEditRestaurant from './components/admin/new/AdminEditRestaurant';
import AdminCreateUser from './components/admin/new/AdminCreateUser';
import AdminUsers from './components/admin/new/AdminUsers';
import AdminEditCoupon from './components/admin/new/AdminEditCoupon';
import AdminEditUser from './components/admin/new/AdminEditUser';
import AdminEditTextMessage from './components/admin/new/AdminEditTextMessage';
import AdminDeletedEntities from './components/admin/AdminDeletedEntities';
import OptOutWordManagement from './components/restaurants/OptOutWordManagement';
// import Testtest from './components/dashboard/Testtest';
// import OwnerDashboardTest from './components/OwnerDashboardTest';

import TextMessagePageTwo from './components/textmessages/TextMessagePageTwo_opti';
import TextMessageFormTwo_opti from './components/textmessages/TextMessageFormTwo_opti';
import TextMessageCouponPage from './components/textmessages/TextMessageCouponPage';
// const Dashboard = lazy(() => import('./pages/Dashboard'));
// const TextMessageList = lazy(() => import('./pages/TextMessageList'));
// const TextMessageForm = lazy(() => import('./pages/TextMessageForm'));
// const Login = lazy(() => import('./pages/Login'));
import ScrollToTop from './components/ScrollToTop';
import VerifyRedeemPage from './components/coupons/VerifyRedeemPage';
import WelcomeTextPageTwo from './components/restaurants/WelcomeTextPageTwo';
import WelcomeTextMessageList from './components/restaurants/WelcomeTextMessageList';
import AllCouponsList from './components/restaurants/AllCouponsList';
import StampManagement from './components/restaurants/StampManagement';
import CustomerStampView from './components/restaurants/CustomerStampview';
import StampRewardForm from './components/restaurants/StampRewardForm';
import RestaurantStampActivity from './components/restaurants/RestaurantStampActivity';
import RewardSetupPage from './components/restaurants/RewardSetupPage';
import CustomerStamp from './components/restaurants/CustomerStamp';
import CustomerStampCollect from './components/restaurants/CustomerStampCollect';
import RestaurantDetailsPage from './components/customer/RestaurantDetails';
// import Checkin from './components/restaurants/Checkin';
import { AuthProvider } from './components/auth/context/AuthContext';
import CustomerSubscriptions from './components/customer/CustomerSubscriptions';
import CustomerPlaylists from './components/customer/CustomerPlaylists';
import CustomerPlaylistDetails from './components/customer/CustomerPlaylistDetails';
import SubscribedRestaurantsPage from './components/customer/SubscribedRestaurantsPage';

import CustomerPrivateRoute from './components/auth/CustomerPrivateRoute';
import LoginCustomer from './components/customer/LoginCustomer';
import CustomerSettings from './components/customer/CustomerSettings';
import OwnerPrivateRoute from './components/auth/OwnerPrivateRoute';
import ErrorPage from './components/auth/ErrorPage';
import OwnerHome from './components/dashboard/OwnerHome';
import OwnerSettings from './components/dashboard/OwnerSettings';

// import MembershipNew from './components/membership/MembershipNew';
// import MembershipInfo from './components/membership/MembershipInfo';
// import MembershipPayment from './components/membership/MembershipPayment';

// import StripeProvider from './components/provider/StripeProvider';
// import MembershipPaymentStripe from './components/membership/MembershipPaymentStripe';
// import MembershipSuccess from './components/membership/MembershipSuccess';

//
// Membership Components
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import MembershipPlans from './components/subscription/MembershipPlans';
import CustomCheckout from './components/subscription/CustomCheckout';
import PaymentSuccess from './components/subscription/PaymentSuccess';
import PaymentFailed from './components/subscription/PaymentFailed';
import MembershipInfo from './components/membership/MembershipInfo';
import SavedPaymentMethods from './components/subscription/SavedPaymentMethods';
// import TransactionHistory from './components/subscription/TransactionHistory';

// Subscription Components
import MembershipPlansTest from './components/testsubscription/newconvo/MembershipPlans';
import MembershipInfoTest from './components/testsubscription/newconvo/MembershipInfo';
import CheckoutTest from './components/testsubscription/newconvo/Checkout';

// import CreditPurchaseTest from './components/testsubscription/newconvo/CreditPurchase';
// import CreditPurchaseSuccessTest from './components/testsubscription/newconvo/CreditPurchaseSuccess';

import CreditPurchaseSelection from './components/testsubscription/newconvo/CreditPurchaseSelection';
import CreditPurchaseCheckout from './components/testsubscription/newconvo/CreditPurchaseCheckout';
import CreditHistory from './components/testsubscription/newconvo/CreditHistory';
import LocationSearch from './components/testsubscription/newconv-12-30/LocationSearch';

// import PaymentMethodsTest from './components/testsubscription/newconvo/PaymentMethods';
// import BillingHistoryTest from './components/testsubscription/newconvo/BillingHistory';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route
              path='/test/location'
              element={
                // <CustomerPrivateRoute>
                // <CustomerHome>
                <LocationSearch />
                // </CustomerHome>
                // </CustomerPrivateRoute>
              }
            />

            <Route
              path='/owner/test/membership'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <MembershipInfoTest />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/test/membershipplans'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <MembershipPlansTest />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/test/checkout'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <CheckoutTest />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            {/* <Route
              path='/owner/test/credit'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <CreditPurchaseTest />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            /> */}
            <Route
              path='/owner/test/credits'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <CreditPurchaseSelection />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/test/credits/checkout'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <Elements stripe={stripePromise}>
                      <CreditPurchaseCheckout />
                    </Elements>
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/credithistory'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <CreditHistory />
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route path='/' element={<LandingPage />} />
            <Route path='/owner/login' element={<OwnerLogin />} />
            <Route path='/owner/signup' element={<OwnerSignup />} />

            <Route
              path='/owner/dashboard'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <OwnerDashboard />
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/owner/settings'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <OwnerSettings />
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/restaurants/new'
              element={
                <OwnerPrivateRoute>
                  <OwnerHome>
                    <CreateRestaurant />
                  </OwnerHome>
                </OwnerPrivateRoute>
              }
            />
            {/* restaurant dashboard */}
            <Route
              path='/restaurant/:restaurantId'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <RestaurantDashboard />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/restaurant/:restaurantId/details'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <RestaurantDetails />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            {/* CUSTOMER PAGE */}
            <Route
              path='/:restaurantId'
              element={
                <CustomerHome>
                  <RestaurantDetailsPage />
                </CustomerHome>
              }
            />
            <Route
              path='/settings'
              element={
                <CustomerPrivateRoute>
                  <CustomerHome>
                    <CustomerSettings />
                  </CustomerHome>
                </CustomerPrivateRoute>
              }
            />
            <Route
              path='/subscriptions'
              element={
                <CustomerPrivateRoute>
                  <CustomerHome>
                    <CustomerSubscriptions />
                  </CustomerHome>
                </CustomerPrivateRoute>
              }
            />
            {/* <Route
              path='/subscriptions'
              element={
                <CustomerHome>
                  <SubscribedRestaurantsPage />
                </CustomerHome>
              }
            /> */}
            <Route
              path='/playlists'
              element={
                <CustomerPrivateRoute>
                  <CustomerHome>
                    <CustomerPlaylists />
                  </CustomerHome>
                </CustomerPrivateRoute>
              }
            />

            {/* <Route
              path='/playlists'
              element={
                <CustomerHome>
                  <CustomerPlaylists />
                </CustomerHome>
              }
            /> */}
            <Route
              path='/playlists/:playlistId'
              element={
                <CustomerPrivateRoute>
                  <CustomerHome>
                    <CustomerPlaylistDetails />
                  </CustomerHome>
                </CustomerPrivateRoute>
              }
            />
            {/* <Route
              path='/:restaurantId/:customerId'
              element={<RestaurantDetailsPage />}
            /> */}
            <Route
              path='/restaurant/:restaurantId/subscribers'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <SubscriberListTwo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            <Route element={<NotFound />} />

            {/* <Route
          path='/restaurant/:restaurantId/text-messages'
          element={<TextMessagePage />}
        /> */}
            {/* <Route
          path='/restaurant/:restaurantId/textmessages/create'
          element={<TextMessageForm />}
        /> */}

            {/* <Route
          path='/restaurant/:restaurantId/text-messages'
          element={<TextMessageListTwo />}
        /> */}
            {/* best */}
            {/* <Route
          path='/restaurant/:restaurantId/text-messages/new'
          element={<TextMessageCreateTwo />}
        /> */}
            {/* <Route
            path='/restaurant/:restaurantId/text-messages/new/'
            element={
              <Home>
                <TextMessageFormTwo />
              </Home>
            }
          />
          <Route
            path='/restaurant/:restaurantId/messages/:messageId/edit/:action'
            element={
              <Home>
                <TextMessageFormTwo />
              </Home>
            }
          /> */}

            <Route
              path='/restaurant/:restaurantId/text-messages/new/'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <TextMessageFormTwo_opti />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/restaurant/:restaurantId/messages/:messageId/edit/:action'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <TextMessageFormTwo_opti />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            {/* <Route
            path='/restaurant/:restaurantId/text-messages'
            element={
              <Home>
                <TextMessagesPage />
              </Home>
            }
          /> */}
            <Route
              path='/restaurant/:restaurantId/text-messages'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <TextMessagePageTwo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/restaurant/:restaurantId/messages/:messageId/coupons'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <TextMessageCouponPage />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            {/* <Route path='/testtest' element={<Testtest />} /> */}
            {/* <Route
          path='/restaurant/:restaurantId/text-messages'
          element={<TextMessageFormRes />}
        /> */}
            {/* best end */}

            <Route
              path='/restaurant/:restaurantId/qr-code'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <QRCodePage />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            {/* <Route
            path='/restaurant/:restaurantId/welcometext'
            element={
              <Home>
                <WelcomeTextPage />
              </Home>
            }
          /> */}
            <Route
              path='/restaurant/:restaurantId/welcometext'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <WelcomeTextPageTwo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/restaurant/:restaurantId/welcometext/view'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <WelcomeTextMessageList />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            {/* <Route
          path='/restaurant/:restaurantId/coupons'
          element={<CouponList />}
        /> */}
            {/* <Route
              path='/restaurant/:restaurantId/couponss'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <CouponTemplateManagement />
                  </Home>
                </OwnerPrivateRoute>
              }
            /> */}
            <Route
              path='/restaurant/:restaurantId/coupons'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <AllCouponsList />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            {/* <Route
            path='/restaurant/:restaurantId/checkin'
            element={
              <Home>
                <Checkin />
              </Home>
            }
          /> */}
            {/* <Route
            path='/restaurant/:restaurantId/stamp'
            element={
              <Home>
                <StampManagement />
              </Home>
            }
          /> */}
            {/* <Route
            path='/restaurant/:restaurantId/stamp'
            element={
              <Home>
                <StampRewardForm />
              </Home>
            }
          /> */}
            <Route
              path='/restaurant/:restaurantId/reward'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <RewardSetupPage />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/restaurant/:restaurantId/reward/activity'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <RestaurantStampActivity />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            {/* <Route
              path='/stamp'
              element={
                // <Home>
                <CustomerStampView />
                // </Home>
              }
            /> */}
            {/* <Route
              path='/restaurant/:restaurantId/coupons/new'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <CouponForm />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/restaurant/:restaurantId/coupons/edit/:couponId'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <CouponForm />
                  </Home>
                </OwnerPrivateRoute>
              }
            /> */}
            {/* <Route
          path='/restaurant/:restaurantId/coupons/create'
          element={<CreateCouponForm />}
        /> */}
            {/* <Route
              path='/restaurant/:restaurantId/membership'
              element={
                <OwnerPrivateRoute>
                  <Home>
                  
                    <MembershipInfo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/restaurant/:restaurantId/membership/upgrade'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <StripeProvider>
                      <MembershipPayment />
                    </StripeProvider>
                  </Home>
                </OwnerPrivateRoute>
              }
            /> */}
            {/* <Route
              path='/owner/membership'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <MembershipInfo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/membership/upgrade'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <StripeProvider>
                      <MembershipPaymentStripe />
                    </StripeProvider>
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            <Route
              path='/owner/membership/success'
              element={
                <OwnerPrivateRoute>
                  <MembershipSuccess />
                </OwnerPrivateRoute>
              }
            /> */}

            {/* membership previous version. */}
            {/* <Route
              path='/owner/membership'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <MembershipPlans />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/owner/membership/checkout'
              element={
                <OwnerPrivateRoute>
                  <Elements stripe={stripePromise}>
                    <CustomCheckout />
                  </Elements>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/owner/membership/payment-success'
              element={
                <OwnerPrivateRoute>
                  <PaymentSuccess />
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/owner/membership/info'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <MembershipInfo />
                  </Home>
                </OwnerPrivateRoute>
              }
            />
            <Route
              path='/owner/membership/saved'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <Elements stripe={stripePromise}>
                      <SavedPaymentMethods />
                    </Elements>
                  </Home>
                </OwnerPrivateRoute>
              }
            /> */}

            <Route
              path='/restaurant/:restaurantId/opt-out-word'
              element={
                <OwnerPrivateRoute>
                  <Home>
                    <OptOutWordManagement />
                  </Home>
                </OwnerPrivateRoute>
              }
            />

            {/* <Route
          path='/restaurant/:restaurantId/subscribers'
          element={<MembershipPage />}
        /> */}
            <Route
              path='/redeem/:couponId'
              element={<CouponRedemptionPage />}
            />
            <Route
              path='/verify-redeem/:couponId'
              element={<VerifyRedeemPage />}
            />
            <Route path='/landing' element={<LandingPageTwo />} />

            {/* <Route
          path='/restaurant/:restaurantId/subscribers'
          element={<ProtectedRoute role='owner' />}
        >
          <Route path='' element={<SubscriberList />} />
        </Route> */}

            {/* <Route path='/subscribers' element={<SubscriberList />} /> */}

            {/* <Route
          path='/restaurant/:restaurantId/coupons/new'
          element={<CreateCouponForm />}
        /> */}

            {/* customer only access */}

            {/* admin only access */}

            {/* <Route path='/restaurants' element={<RestaurantList />} /> */}
            {/* <Route path='/messages/new' element={<MessageForm />} /> */}

            {/* <Route
          path='/restaurant/:restaurantId/subscribers'
          element={<SubscribersPage />}
        /> */}
            {/* <ProtectedRoute
          path='/subscribe/:restaurantId'
          element={<SubscribersPage />}
          role='customer'
        /> */}
            {/* <Route
          path='/restaurant/:restaurantId/subscribers'
          element={<ProtectedRoute role='owner' />}
        >
          <Route path='' element={<SubscribersPage />} />
        </Route> */}

            {/* <Route path='/owner-login' element={<OwnerLogin />} />
        <Route path="/owner-signup" element={<OwnerSignup />} /> */}
            <Route
              path='/customer-login'
              element={
                <CustomerHome>
                  <LoginCustomer />
                </CustomerHome>
              }
            />
            {/* <Route path='/verify-otp' element={<VerifyOTP />} /> */}
            {/* <Route path='/customer/login' element={<CustomerLogin />} /> */}

            {/* I DON'T KNOW WHAT THIS IS, BUT MIGHT BE IMPORTANT 12-28 */}
            {/* <Route path='/customer/verify-otp' element={<VerifyOTP />} /> */}
            {/* I DON'T KNOW WHAT THIS IS, BUT MIGHT BE IMPORTANT 12-28 */}

            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            {/* <Route
          path='/subscribe/:restaurantId'
          element={<QRCodeSubscribePage />}
        /> */}
            <Route
              path='/subscribe/:restaurantId'
              element={
                <CustomerHome>
                  <CustomerSubscribe />
                </CustomerHome>
              }
            />

            {/* <Route path='/stamp/:restaurantId' element={<CustomerStamp />} /> */}

            {/* this is for when customer scan qrcode for stamp */}
            <Route
              path='/stamp/:restaurantId'
              element={<CustomerStampCollect />}
            />

            {/* <Route path='/owner-login' component={OwnerLogin} /> */}
            {/* <Route path='/customer-login' component={CustomerLogin} /> */}
            {/* <Route path='/verify-otp' component={VerifyOTP} /> */}
            {/* <Route path='/owner-dashboard' component={OwnerDashboard} /> */}
            {/* <Route path='/customer-dashboard' component={CustomerDashboard} /> */}
            {/* <Route path='/admin-dashboard' component={AdminDashboard} /> */}

            {/* <Route
              path='/unsubscribe/:restaurantId'
              component={UnsubscribePage}
            /> */}

            {/* <ProtectedRoute path="/owner-dashboard" component={OwnerDashboard} role="owner" />
                <ProtectedRoute path="/customer-dashboard" component={CustomerDashboard} role="customer" />
         */}

            <Route path='/admin/login' element={<AdminLogin />} />
            <Route path='/admin/signup' element={<AdminSignup />} />
            <Route path='/admin/dashboard' element={<AdminDashboard />} />
            <Route path='/admin/restaurants' element={<AdminRestaurants />} />
            <Route
              path='/admin/restaurants/create'
              element={<AdminCreateRestaurant />}
            />
            <Route
              path='/admin/restaurants/:restaurantId/edit'
              element={<AdminEditRestaurant />}
            />

            {/* erase this later */}
            {/* <Route path='/test' element={<Dashboard />} /> */}
            {/* <Route path='/customer/dashboard' element={<CustomerDashboard />} /> */}
            {/* <Route path='/home' element={<Home />} /> */}
            {/* <Route path='/admin/subscribers' element={<AdminSubscribers />} /> */}
            {/* <Route path='/admin/memberships' element={<AdminMemberships />} /> */}
            {/* <Route path='/admin/deleted' element={<AdminDeletedEntities />} /> */}

            {/* ADMIN OWNER===================== */}
            <Route path='/admin/user' element={<AdminUsers />} />
            <Route path='/admin/user/create' element={<AdminCreateUser />} />
            <Route path='/admin/user/edit/:id' element={<AdminEditUser />} />
            <Route path='/admin/textmessages' element={<AdminTextMessages />} />

            <Route
              path='/admin/textmessages/create'
              element={<AdminCreateTextMessage />}
            />
            <Route
              path='/admin/textmessages/edit/:id'
              element={<AdminEditTextMessage />}
            />
            <Route path='/admin/coupons' element={<AdminCoupons />} />
            <Route path='/admin/customers' element={<AdminCustomers />} />
            <Route
              path='/admin/customer/create'
              element={<AdminCreateCustomer />}
            />

            {/* <Route path='/admin/owners' element={<AdminOwners />} />
          <Route path='/admin/owner/create' element={<AdminCreateOwner />} /> */}

            {/* =====================ADMIN OWNER */}

            {/* ADMIN TEXT MESSAGE===================== */}

            {/* =====================ADMIN TEXT MESSAGE */}

            {/* ADMIN COUPON===================== */}

            {/* <Route path='/admin/coupons/create' element={<AdminCreateCoupon />} /> */}
            {/* <Route path='/admin/coupons/edit/:id' element={<AdminEditCoupon />} /> */}

            {/* ADMIN CUSTOMER===================== */}

            {/* <Route
  path='/admin/customer/edit:id'
  element={<AdminEditCus />}
/> */}

            {/* ADMIN COUPON TEMPLATE===================== */}
            {/* <Route
              path='/admin/coupontemplates'
              element={<AdminCouponTemplates />}
            /> */}
            {/* <Route
              path='/admin/coupontemplates/create'
              element={<AdminCreateCouponTemplate />}
            /> */}

            <Route path='/error' element={<ErrorPage />} />
          </Routes>
          <ToastWrapper />

          {/* <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
          {/* <ToastContainer
        position='top-right'
        className='p-3'
        toastClassName={() =>
          'relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer bg-blue-600 text-white'
        }
      /> */}
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
